export default [
    // 发票列表
    {
        path: '/invoice/list',
        component: () => import(/* webpackChunkName:"invoice-list"*/ '@/pages/invoice/invoiceList/index.vue'),
        name: 'invoiceList',
        meta: {
            title: '发票抬头',
        },
    },
    // 发票添加、发票编辑
    {
        path: '/invoice/add',
        component: () => import(/* webpackChunkName:"invoice-add"*/ '@/pages/invoice/addInvoice/index.vue'),
        name: 'invoiceAdd',
        meta: {
            title: '添加发票',
            wxConfig: ['chooseInvoiceTitle'],
        },
    },
];
